module.exports = __webpack_public_path__ + "static/img/todomath_main_top_ani.0a12906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_top_ani.png
// module id = tbpf
// module chunks = 18